/** Generic empty state with optional illustration via ASCII or icon. */
export default function EmptyState({ title, description, action, icon: Icon, testid }) {
  return (
    <div className="border border-dashed border-border p-12 text-center" data-testid={testid}>
      {Icon && <Icon className="w-12 h-12 mx-auto mb-4 text-muted-foreground" strokeWidth={1.2} />}
      <div className="label-eyebrow mb-2">Nothing here yet</div>
      <h3 className="font-bold text-2xl mb-2" style={{ fontFamily: "var(--font-heading)" }}>{title}</h3>
      {description && <p className="text-muted-foreground max-w-md mx-auto text-sm mb-6">{description}</p>}
      {action}
    </div>
  );
}
